// extracted by css-extract-rspack-plugin
export default {"kebabButton":"kebab-menu-module__kebabButton__UuCPY"};